import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">热门话题标签</h2>
          <p className="text-foreground-500 text-sm md:text-base">全网最热的瓜田话题，点击查看详情</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href={`#cards`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="font-medium text-sm md:text-base text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                #{topic.tag}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className={`text-[10px] ${topic.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : topic.trend === 'hot' ? 'ri-fire-line text-accent-500' : 'ri-arrow-down-line text-secondary-500'}`}></i>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}